import React from 'react';

export function textVersions(value, originalLanguage = 'it') {
  return value && typeof value === 'object' ? value : {[originalLanguage]:value || ''};
}

export function hasLocalizedText(value) {
  return typeof value === 'string' ? !!value.trim() : !!value && typeof value === 'object' && Object.values(value).some(text => typeof text === 'string' && text.trim());
}

export default function BilingualField({label, value, onChange, originalLanguage='it', multiline=true, testId, maxLength=10000, rows=3, onBlur, disabled=false}) {
  const versions=textVersions(value,originalLanguage);
  const Control=multiline ? 'textarea' : 'input';
  return <fieldset className="min-w-0"><legend className="text-sm font-medium mb-2">{label}</legend>
    <div className="grid sm:grid-cols-2 gap-3">{['it','en'].map(language=><label key={language} className="block text-sm">{language==='it' ? 'Italiano' : 'English'}
      <Control disabled={disabled} onBlur={onBlur} className="block w-full mt-1 rounded-md border border-[#E2DACB] bg-white p-2 text-sm" rows={multiline ? rows : undefined} maxLength={maxLength} data-testid={testId ? `${testId}${language==='en' ? '-en' : ''}` : undefined} value={versions[language] || ''} onChange={event=>onChange({...versions,[language]:event.target.value})}/>
    </label>)}</div>
  </fieldset>;
}
